import { Link } from "react-router-dom";
import { useSeo } from "../components/site/Seo";
import { useLang } from "../i18n/lang";

export default function Legal({ doc }) {
  const { t, to } = useLang();
  useSeo(...t.seo[doc]);
  const [title, sections] = t.legalDocs[doc];
  return (
    <main className="px-6 sm:px-10 lg:px-14 pt-40 pb-32" data-testid={`legal-${doc}`}>
      <h1 className="f-serif font-light text-5xl sm:text-6xl tracking-[-0.02em]">{title}</h1>
      <p className="mt-4 f-mono text-xs text-[#555555]">[{t.legalDocs.draft}]</p>
      <div className="mt-16 max-w-3xl">
        {sections.map(([h, p], i) => (
          <section key={i} className="grid grid-cols-1 sm:grid-cols-3 gap-4 py-6 border-t border-[#1A1A1A]/12">
            <h2 className="eyebrow !text-[0.68rem] text-[#555555] pt-1">{h}</h2>
            <p className="sm:col-span-2 leading-relaxed">{p}</p>
          </section>
        ))}
      </div>
      <Link to={to("")} className="mt-12 inline-block eyebrow link-line">{t.notFound.cta}</Link>
    </main>
  );
}

export const NotFound = () => {
  const { t, to } = useLang();
  return (
    <main className="min-h-[80vh] px-6 sm:px-10 lg:px-14 pt-48" data-testid="not-found">
      <p className="f-mono text-xs text-[#555555]">404</p>
      <h1 className="f-serif font-light text-5xl sm:text-7xl mt-6">{t.notFound.title}</h1>
      <Link to={to("")} className="mt-10 inline-block eyebrow link-line">{t.notFound.cta}</Link>
    </main>
  );
};
